export const webCookie = {
    set(name: string, value: string, expire = 3600000): void {
      let domain, expires;
      value = value || '';
  
      if (expire) {
        const date = new Date();
        date.setTime(date.getTime() + expire);
        expires = '; expires=' + date.toUTCString();
      } else {
        expires = '';
      }
  
      const {host} = location;
  
      if (host.indexOf(':') > 1) {
        // yes ":" in a domain - it's localhost or something similar
        document.cookie = name + '=' + value + expires + '; path=/';
      } else {
        // Remember the cookie on all subdomains.
        //
        // Start with trying to set cookie to the top domain.
        // (example: if user is on foo.com, try to set
        //  cookie to domain ".com")
        //
        // If the cookie will not be set, it means ".com"
        // is a top level domain and we need to
        // set the cookie to ".foo.com"
        const domainParts = host.split('.');
        domainParts.shift();
        domain = '.' + domainParts.join('.');
  
        document.cookie = `${name}=${value}${expires}; path=/; domain=${domain}`;
  
        // check if cookie was successfuly set to the given domain
        // (otherwise it was a Top-Level Domain)
        if (this.get(name) == null || this.get(name) !== value) {
          // append "." to current domain
          domain = '.' + host;
          document.cookie = `${name}=${value}${expires}; path=/; domain=${domain}`;
        }
      }
    },
  
    get(name: string): string | null {
      const regexp = new RegExp(`(?:^${name}|;\\s*${name})=(.*?)(?:;|$)`, 'g');
      const data = regexp.exec(document.cookie);
      return data ? data[1] : null;
    },
  
    erase(name: string): void {
      this.set(name, '', -1);
    }
  };
  